import { faArrowRightFromBracket, faBars, faMagnifyingGlass, faSliders } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoNav from '../../images/LogoSmallColored-nav.png';
import $ from 'jquery'
import React, { useEffect, useState } from 'react';
import FiltrationPopup from '../FiltrationPopup/FiltrationPopup';
import SearchNavbar from '../SearchNavbar/SearchNavbar';
import { Link, useNavigate } from 'react-router-dom';
import { useApi } from '../Store/ApiContext';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import CallToActionTopBar from '../CallToActionTopBar/CallToActionTopBar';
import { Dropdown } from 'react-bootstrap';
import { clarity } from 'react-microsoft-clarity';

const clarityProjectId = "tm0ccezofn" // Clarity project ID

export default function Navbar({ setData, baseUrl }) {
    if (process.env.NODE_ENV === 'production') clarity.init(clarityProjectId);

    const location = useLocation();

    const { getData, getSlug } = useApi();
    const [dataInfo, setDataInfo] = useState({})

    async function fetchData() {
        const slug = getSlug();
        const data = await getData(slug);
        console.log(data);
        setData(data);
    }

    function togglePopup() {
        if ($(".filter-container").hasClass("animate__backInUp")) {
            $(".filter-container").removeClass("animate__backInUp");
            $(".filter-container").addClass("animate__backOutUp");
            $(".filter-popup").delay(500).fadeOut(0);
        } else {
            $(".filter-container").removeClass("animate__backOutUp");
            $(".filter-container").addClass("animate__backInUp");
            $(".filter-popup").fadeIn(0);
        }
    }
    function toggleSearch() {
        if ($(".parent-search").hasClass("animate__fadeInDown")) {
            $(".parent-search").removeClass("animate__fadeInDown");
            $(".parent-search").addClass("animate__fadeOutUp");
            $('.search-navbar').delay(500).fadeOut(0);

        } else {
            $(".parent-search").removeClass("animate__fadeOutUp");
            $(".parent-search").addClass("animate__fadeInDown");
            $(".search-navbar").fadeIn(0);
        }
    }
    function logout(params) {
        localStorage.removeItem("token");
        window.location.reload();
    }

    // get data info
    async function getDataInfo() {
        const slug = getSlug();
        const { data } = await axios({
            method: "get",
            url: `${baseUrl}listing/info/${slug}`,
            headers: {
                'Content-Type': 'application/json',
            }
        })
        console.log(data);
        return data.data
    }

    async function fetchInfoOrgData() {
        const data = await getDataInfo();
        console.log(data);
        setDataInfo(data);
    }

    function ProtectedAuthentication(props) { // shield for login and register
        const logoutElement = <Dropdown.Item >
            <h6 className='m-1 text-end' onClick={() => { logout(); }}>تسجيل الخروج</h6>
        </Dropdown.Item>
        let token = localStorage.getItem("token")
        if (!token) {
            return props.children
        }
        return logoutElement;
    }


    useEffect(() => {
        fetchInfoOrgData();
    }, []);

    useEffect(() => {
        if (dataInfo?.orgName) {
            document.title = dataInfo?.orgName;

            //fav.icon

            // let link = document.querySelector("link[rel~='icon']");
            // if (!link) {
            //     link = document.createElement('link');
            //     link.rel = 'icon';
            //     document.getElementsByTagName('head')[0].appendChild(link);
            // }
            // link.href = dataInfo?.orgLogo;
        }

    }, [dataInfo])


    return (<>
        <nav>
            <div className='d-flex justify-content-between align-items-center navbar px-1 px-sm-3'>
                <div className='item-1 cursor-pointer'>
                    <Link to={"/"}>
                        {dataInfo?.orgLogo ? <img src={dataInfo?.orgLogo} className='w-100 p-2 logo-navbar' alt='logo' /> : <h3 className='text-myPrimary fw-bold'>{dataInfo?.orgName}</h3>}
                    </Link>
                </div>
                <div className='item-2 d-flex align-items-center '>
                    <div className='d-flex align-items-center '>
                        <FontAwesomeIcon icon={faMagnifyingGlass} className='icon-search-navbar mx-2 cursor-pointer' onClick={toggleSearch} />
                        <FontAwesomeIcon icon={faSliders} className=' mx-1 filter cursor-pointer' onClick={togglePopup} />
                        <div className='me-0'>
                            <div className='profile-menu-dropdown'>
                                <Dropdown>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        <div className='profile-menu-dropdown-toggle'>
                                            {/* <FontAwesomeIcon className='menu-icon' icon={faBars} /> */}
                                            <svg className='profile-icon' version="1.0" width="35px" height="35px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet" fill='#074acc'>
                                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
                                                    <path d="M2365 4599 c-705 -68 -1335 -506 -1646 -1144 -483 -994 -87 -2195 893 -2709 783 -410 1735 -271 2376 348 144 139 297 344 389 524 38 72 43 91 43 148 0 78 -15 118 -67 174 -51 58 -102 80 -184 80 -54 0 -77 -5 -120 -28 -58 -30 -83 -62 -183 -236 -27 -47 -53 -86 -56 -86 -4 0 -27 25 -50 55 -71 91 -242 248 -349 320 -55 37 -101 70 -101 74 0 5 10 16 21 27 72 65 181 268 219 409 33 119 39 338 12 465 -112 541 -631 897 -1173 804 -418 -72 -745 -389 -831 -804 -27 -127 -21 -345 12 -465 38 -141 147 -344 219 -409 11 -11 21 -23 21 -27 0 -5 -36 -31 -79 -59 -136 -87 -181 -152 -181 -262 1 -143 107 -250 250 -252 65 -1 103 13 190 72 164 109 325 161 530 169 114 4 152 2 240 -17 172 -35 325 -109 459 -220 65 -55 177 -181 202 -227 12 -22 11 -27 -11 -44 -53 -40 -261 -140 -361 -173 -393 -131 -812 -101 -1175 83 -303 153 -535 385 -686 685 -183 365 -212 783 -82 1175 45 135 137 313 221 424 399 535 1088 752 1721 541 363 -120 670 -377 857 -714 65 -118 87 -144 147 -174 40 -20 67 -26 117 -26 82 0 133 22 184 80 52 56 67 96 67 174 0 57 -5 76 -43 148 -378 736 -1185 1176 -2012 1097z m297 -1283 c95 -21 171 -60 241 -126 217 -203 225 -524 18 -731 -104 -104 -216 -151 -361 -151 -145 0 -257 47 -361 151 -99 100 -149 218 -149 356 0 145 53 268 159 368 75 71 151 112 243 132 82 18 128 18 210 1z" />
                                                    <path d="M4315 2813 c-89 -20 -164 -76 -196 -148 -25 -54 -25 -157 0 -210 62 -133 228 -188 353 -118 179 101 181 346 3 443 -49 28 -121 42 -160 33z" />
                                                </g>
                                            </svg>
                                        </div>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <ProtectedAuthentication>
                                            <Dropdown.Item >
                                                <Link to={"/login"}>
                                                    <h6 className='m-1 text-end'>تسجيل الدخول</h6>
                                                </Link>
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                <Link to={"/register"}>
                                                    <h6 className='m-1 text-end'>انشاء حساب</h6>
                                                </Link>
                                            </Dropdown.Item>
                                        </ProtectedAuthentication>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>




                </div>

            </div>
            <div className='search-navbar'>
                <SearchNavbar setData={setData} toggleSearch={toggleSearch} />
            </div>

            <div className='filter-popup'>
                <FiltrationPopup setData={setData} togglePopup={togglePopup} />
            </div>
            {/* Start seeing data on the Clarity dashboard with your id */}
            
        </nav>
    </>
    )
}
